module.exports = __webpack_public_path__ + "static/media/assa-bumper_selected.1b756429.svg";